import {
    DateIO,
    Form,
    Instance,
    Objekt,
    SelectField,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from './assetService';
import { LanguageService } from './languageService';
import { ModelService } from './modelService';
import { PersonService } from './personService';
import { PlanService } from './planService';

export class HuntingPackageService extends ModelService {
    static readonly inject = [
        'instances',
        'languageService',
        'assetService',
        'personService',
        'planService',
    ];

    constructor(
        instances: Instance,
        $languageService: LanguageService,
        $assetService: AssetService,
        private personService: PersonService,
        private planService: PlanService,
    ) {
        super(
            'hunting_package-hunting_packages-title',
            instances,
            $languageService,
            $assetService,
        );
    }

    getAllByOrganization(organizationId: string, opt_params: object) {
        return this.getAllBy('organizations', organizationId, opt_params);
    }

    createByOrganization(organizationId: string, huntingPackage: Objekt) {
        return this.createBy('organizations', organizationId, huntingPackage);
    }

    handleForm(form: Form, opt_entityName?: string) {
        const peopleField = form.findByModel<SelectField>(
            'hunting_package.person_ids',
        );
        const plansField = form.findByModel<SelectField>(
            'hunting_package.plan_id',
        );
        const organizationField = form.findByModel<SelectField>(
            'hunting_package.organization_id',
        );
        const startAtField = form.findByModel('hunting_package.start_at');
        const endAtField = form.findByModel('hunting_package.end_at');

        organizationField.on('change', (organizationId: string) => {
            if (organizationId) {
                peopleField.showLoader();
                this.personService
                    .getAllByOrganization(organizationId, {
                        fields: 'id,name',
                    })
                    .then((response) => {
                        const people = response.get<Objekt[]>('people');
                        peopleField.setOptions(people, 'id', 'name');
                    });
                plansField.showLoader();
                this.planService
                    .getAllByOrganization(organizationId, {
                        fields: 'id,name',
                    })
                    .then((response) => {
                        const plans = response.get<Objekt[]>('plans');
                        plansField.setOptions(plans, 'id', 'full_name');
                    });
            } else {
                peopleField.setOptions([]);
                plansField.setOptions([]);
            }
        });

        startAtField.on('change', (startAt: string) => {
            const endAt = DateIO.format(
                DateIO.addYears(DateIO.parse(startAt), 1),
            );
            endAtField.setValue(endAt);
        });
    }
}

export const huntingPackageService = app.service('huntingPackageService', HuntingPackageService);
